import { FLAGS, getFlagsDictionary, getListingBadgeName } from '@/components/srp/search-list/domain'
import { type Listing } from '@/types/search'

/**
 * Gets the badge value for a listing based on its flags and the category it belongs to.
 *
 * @param {Listing} item - The listing to get the badge value for.
 * @param {number} categoryId - The listing's category id.
 *
 * @returns {string|undefined} The badge value for the listing, or null if no badge is present.
 */
export const getListingBadgeValue = (item: Listing, categoryId: number) => {
  const flagsDictionary = getFlagsDictionary(item.flags)
  const imageBadge = getListingBadgeName(categoryId, flagsDictionary[FLAGS.CATEGORY_BADGE])

  return imageBadge
}
